import React, { useEffect } from "react"
import {
  Tabs,
  Tab,
  CircularProgress,
  createTheme,
  ThemeProvider,
  Box,
} from "@mui/material"
import {
  INewPipeLineTab,
  INewTableCellChangePayload,
} from "../../../util/interface"
import {
  activeTabSelector,
  newPipeLineActiveDataSelector,
  newPipeLineBaseDataAsync,
  newPipelineCellChange,
  updateTabIndex,
} from "../MonitorSlice"
import { useAppDispatch, useAppSelector } from "../../../util/hooks"
import { theme as baseTheme } from "../../../util/CustomTheme"
import NewPipeLineConfigTable from "../../../components/NewPipeLineConfigTable"
import { NewPipeLineTabs } from "../../../util/NewPipelineConfig"
export const redThemedTabs = createTheme({
  palette: {
    primary: {
      main: "#25d4cf", // Set your desired secondary color
      light: "#25d4cf",
      dark: "#25d4cf",
    },
    customColors: {
      positive: "",
      textGreen: "",
      textGrey1: "",
      hoverPrimary: "",
      buttonBackgroundGrey: "",
    },
    tableColors: {
      header: "",
      body: "",
      borderGreen: "",
    },
    borderColors: {
      50: "",
    },
    textColors: {
      grey1: "",
      themeWhite: "",
      grey2: "",
      grey3: "",
      grey4: "",
    },
    backgrounds: {
      50: "",
    },
    status: {
      green: "",
      yellow: "",
      neutral: "",
      red: "",
    },
  },
})

export const themeMui = createTheme({
  ...baseTheme,
  components: {
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontSize: 14,
          height: 31,
        },
      },
    },
  },
})

export const themeMuiForTextField = createTheme({
  ...baseTheme,
  components: {
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontSize: 13,
          height: 26,
        },
      },
    },
  },
})
const NewPipeLineTableWrapper = () => {
  // Selectors to retrieve data from the Redux store
  const data = useAppSelector(newPipeLineActiveDataSelector)
  const allConfigData = useAppSelector(
    (state) => state.monitor.newPipeLine.tableData,
  )
  const status = useAppSelector((state) => state.monitor.newPipeLine.status)

  const dispatch = useAppDispatch()
  const activeTab = useAppSelector(activeTabSelector)

  // Handle tab change
  const handleTabChange = (event: any, newValue: string) => {
    dispatch(updateTabIndex(newValue))
  }

  // Effect to fetch data if the selected tab's data is empty
  useEffect(() => {
    if (!allConfigData[activeTab].length) {
      dispatch(newPipeLineBaseDataAsync())
    }
  }, [activeTab])

  // Handle cell changes in the table
  const cellChange = (payload: INewTableCellChangePayload) => {
    dispatch(newPipelineCellChange(payload))
  }

  return (
    <div>
      {/* Tab Navigation */}
      <ThemeProvider theme={redThemedTabs}>
        <Tabs value={activeTab} onChange={handleTabChange} textColor="primary">
          {NewPipeLineTabs.map((obj: INewPipeLineTab) => {
            return (
              <Tab
                sx={{
                  textTransform: "none",
                }}
                value={obj.label}
                label={obj.label}
                key={obj.key}
              />
            )
          })}
        </Tabs>
      </ThemeProvider>

      {/* Loading Indicator or Table Component */}
      {status === "loading" ? (
        <Box
          sx={{
            minHeight: 500,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <NewPipeLineConfigTable
          activeTab={activeTab}
          cellChange={cellChange}
          data={data}
        />
      )}
    </div>
  )
}

export default NewPipeLineTableWrapper
